import React, { useState, useEffect } from 'react';

const EducationForm = ({ education, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    institution: '',
    degree: '',
    period: '',
    description: ''
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (education) {
      setFormData(education);
    }
  }, [education]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.institution.trim()) {
      newErrors.institution = 'Institution is required';
    }

    if (!formData.degree.trim()) {
      newErrors.degree = 'Degree is required';
    }

    if (!formData.period.trim()) {
      newErrors.period = 'Period is required';
    }

    if (!formData.description.trim()) {
      newErrors.description = 'Description is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      onSave(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>{education ? 'Edit Education' : 'Add New Education'}</h3>

      <div className="form-group">
        <label htmlFor="institution">Institution</label>
        <input
          id="institution"
          type="text"
          name="institution"
          value={formData.institution}
          onChange={handleChange}
          placeholder="e.g., University of Technology"
        />
        {errors.institution && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.institution}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="degree">Degree</label>
        <input
          id="degree"
          type="text"
          name="degree"
          value={formData.degree}
          onChange={handleChange}
          placeholder="e.g., Bachelor of Science in Computer Science"
        />
        {errors.degree && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.degree}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="period">Period</label>
        <input
          id="period"
          type="text"
          name="period"
          value={formData.period}
          onChange={handleChange}
          placeholder="e.g., 2018 - 2022"
        />
        {errors.period && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.period}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="description">Description</label>
        <textarea
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="e.g., Graduated with honors. GPA: 3.8/4.0"
          style={{ width: '100%', padding: '10px', minHeight: '80px', fontFamily: 'inherit', border: '1px solid #ddd', borderRadius: '5px', fontSize: '14px' }}
        />
        {errors.description && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.description}</div>}
      </div>

      <div className="modal-actions">
        <button type="button" className="cancel-btn" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="save-btn">
          {education ? 'Update Education' : 'Create Education'}
        </button>
      </div>
    </form>
  );
};

export default EducationForm;
